import React, { FC } from 'react';
import { UpdateProjectErrorCode } from '@bechtel/types';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UpdateProjectRequestErrorProps } from './types';

const getErrorMessage = (error: UpdateProjectRequestErrorProps['updateProjectError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateProjectErrorCode.EXCEEDED_MAX_ATTACHMENT_FILE_LIMIT:
      return <Trans>Project logo size exceeded max file size limit..</Trans>;
    case UpdateProjectErrorCode.INVALID_COUNTRY:
      return <Trans>Invalid Country.</Trans>;
    case UpdateProjectErrorCode.INVALID_LANGUAGE:
      return <Trans>Invalid Language.</Trans>;
    case UpdateProjectErrorCode.INVALID_STATE:
      return <Trans>Invalid State.</Trans>;
    case UpdateProjectErrorCode.INVALID_SUPPORT_USER:
      return <Trans>Invalid support user.</Trans>;
    case UpdateProjectErrorCode.INVALID_TIME_FORMAT:
      return <Trans>Invalid Time format.</Trans>;
    case UpdateProjectErrorCode.NOT_FOUND:
      return <Trans>Project details not found.</Trans>;
    case UpdateProjectErrorCode.INVALID_DATE_FORMAT:
      return <Trans>Invalid Date format.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const UpdateProjectRequestErrorModal: FC<UpdateProjectRequestErrorProps> = ({ updateProjectError, close }) => {
  return (
    <Modal
      visible
      size={ModalSize.DEFAULT}
      data-testid="update-project-request-error"
      style={{ width: '552px', height: '275px' }}
    >
      <ModalHeader title={t`Update Project Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updateProjectError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateProjectRequestErrorModal;
